/**
 * Pure move-one-item reorder keyed by photoUUID. Shared by the
 * `reorderAssets` reducer and the drag-drop seam call site so the persisted
 * `orderedAssetUUIDs` can never diverge from what the reducer applied.
 * Returns the input array unchanged (same reference) for no-op moves.
 */
export function reorderByPhotoUUID<T extends { photoUUID: string }>(
  list: T[],
  fromPhotoUUID: string,
  toPhotoUUID: string,
  position: 'before' | 'after',
): T[] {
  if (fromPhotoUUID === toPhotoUUID) return list;
  const fromIndex = list.findIndex((i) => i.photoUUID === fromPhotoUUID);
  const toIndex = list.findIndex((i) => i.photoUUID === toPhotoUUID);
  if (fromIndex === -1 || toIndex === -1) return list;
  const next = list.slice();
  const [moved] = next.splice(fromIndex, 1);
  const targetIndex = next.findIndex((i) => i.photoUUID === toPhotoUUID);
  const insertAt = position === 'before' ? targetIndex : targetIndex + 1;
  // DV-2799: a drop back into its own slot (after its predecessor / before its
  // successor) is a no-op too — return the same reference so nothing is
  // marked unsynced and no order PUT is sent.
  if (insertAt === fromIndex) return list;
  next.splice(insertAt, 0, moved);
  return next;
}
